<template>
  <modal ref='modal'>
    <template #header>
      <h5 v-if='checklistItems.length > 1' class="modal-title mt-0">{{ $t('checklist.move_items_to_folder')}}</h5>
      <h5 v-else class="modal-title mt-0">{{ $t('checklist.move_item')}}</h5>
    </template>

    <template #body>
      <form>
        <div class='modal-body'>
          <p class="warning-message" v-if="hasRecords">
            <i class="fas fa-exclamation-triangle"></i>
            {{ $t('checklist.warning_sentence')}}
          </p>
          <div class="form-group">
            <label>
              {{ $t('checklist.select_folders')}}
            </label>
            <multi-select :template='folderTemplate' :getter='getFolders' v-model='selectedFolders' />
          </div>
        </div>

        <div class='modal-footer copy-items-footer'>
          <div>
            <label class="checkbox-container" v-if="hasRecords">
              <input type="checkbox" name="has-records" v-model="willmoveRecords">
              <span class="checkmark"></span>
              {{ $t('checklist.move_files') }}
              {{ $t('checklist.file_options') }}
            </label>
          </div>
          <button type='submit' class="btn btn-outline-primary" :disabled='!canMove' @click.prevent="move">
            {{ $t('checklist.move', { count: checklistItemIds.length }) }}
          </button>
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
  import modal from "../_modal"
  import _multi_select from "../shared/_infinite_multi_select"

  export default {
    components: {
      modal,
      'multi-select': _multi_select,
    },
    props: {
      folder: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        willmoveRecords: false,
        selectedFolders: [],
        checklistItems: [],
      }
    },
    computed: {
      selectedIds() {
        return this.selectedFolders.map(f => f.id)
      },
      canMove() {
        return this.selectedFolders.length > 0
      },
      checklistItemIds() {
        return this.checklistItems.map(c => c.id)
      },
      hasRecords() {
        return this.checklistItems.some(c => c.record.id)
      }
    },
    methods: {
      getFolders(params) {
        const additionalParams = { 'filters[id_not_in]': this.checklistItems.map(f => f.folder.id) }
        return this.listStore.getFolders(Object.assign(additionalParams, params))
      },
      open(checklistItems) {
        this.willmoveRecords = false
        this.selectedFolders = []
        this.checklistItems = checklistItems

        this.$refs.modal.open()
      },
      move() {
        const params = { new_folders: this.selectedIds , move_records: this.willmoveRecords}

        this.store.executeBulkOperation('move', this.checklistItemIds, params).then(() => {
          this.store.sendMetrics({name: 'bulk_move_operation', params: this.$route.params, path: this.$route.fullPath})
          this.$refs.modal.close()
          this.$emit('success')
          this.$toastr.success(this.$t('checklist.processing_checklist'))
        })
      },
    },
  }
</script>
<style lang="sass" scoped>
  .copy-items-footer
    justify-content: space-between
    align-items: flex-start
    div
      width: 62%
  .warning-message
    background: rgba(255, 193, 7, 0.14)
    border-radius: 5px
    padding: 10px
    color: #D39F00
    font-weight: 700
    i
      color: #FFBF00
  .custom-select
    width: 100%
</style>
